import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import './Login.css'
import clsx from 'clsx';
import { Button } from '../../atoms/Button/StyledButton';
import { ChangeForgotPWreq, ForgotPWreq, LogInData, MatchDate, ModalType, initialLoginData } from '../../types/types';
import * as Yup from "yup";
import { useFormik } from 'formik';
import useMediaQueryHeight from '../../../hook/useMediaQueryHeight';
import { AppGeneralContext } from '../../../shared/GeneralContext/GeneralContext';
import { LoginType } from '../../types/Context';
import loginImg from '../../../assets/background_IM.jpeg'
import { MediaDesktop, MediaMobile, MediaTablet } from '../../../api/const/MediaQuery';
import useMediaQuery from '../../../hook/useMediaQuery';
import { getLinkedInAuthUrl, getUser, postChangeForgotPassword, postForgotPassword, postLogin } from 'api/calls';
import { ApiSimpleResponse, LoginRequest, LoginResponse } from 'components/types';
import axios from 'axios';
import { useAuth } from 'shared/auth';
import { code_regex } from 'shared/const';
import Linkedin from 'components/atoms/iconsComponent/Linkedin';
import { LinkedInRedirectType } from 'api/const';
import { useGuestView } from 'shared/GeneralContext/GuestContext';
import { getStartUpByID } from 'api/Api';
import { ForgotPassword } from 'components/organism/ForgotPassword/ForgotPassword';
import { ChooseNewPassword } from 'components/organism/ChooseNewPassword/ChooseNewPassword';


export const Login = () => {
  const loginDataSchema = Yup.object().shape({
    user: Yup.string()
      .required('Please complete this required field.'),
    password: Yup.string()
      .required('Please complete this required field.'),

  });



  
  const {
    setLoginType,
    getUserData,
    setLoadingModal,
    setErrorModal,
    setClosedModal,
    setModal,
    getStartupById,
    setModalDatesIsOpen, setMatchCallDates,
    isForgotPassword, setIsForgotPassword,
    isChooseNewPassword, setIsChooseNewPassword,
    loginType
  } = useContext(AppGeneralContext)
  const { saveAuth, setCurrentUser } = useAuth()
  const { state } = useLocation();
  const location = useLocation()
  const locationState = state as LoginType ?? LoginType.corporate
  const [whoLogsIn, setWhoLogsIn] = useState<LoginType>(locationState)
  const [logInAsText, setLogInAsText] = useState<string>("")
  const navigate = useNavigate();
  const heigth700 = useMediaQueryHeight(700);
  const mobile = useMediaQuery(MediaMobile);
  const tablet = useMediaQuery(MediaTablet);
  const desktop = useMediaQuery(MediaDesktop);
  const buttonsColumns = useMediaQuery(1110);
  const { userGuest, canMatch, resetGuest, setCanMatch } = useGuestView()
  const { auth } = useAuth()
  const [logiDataInfo] = useState<LogInData>({
    ...initialLoginData
  })

  useEffect(() => {
    //controllo se proviene da un profilo guest
    if (userGuest && userGuest.email) {
      formik.setFieldValue("user", userGuest.email)
      formik.setFieldValue("password", "")
    }
  }, [userGuest])

  useEffect(() => {
    let uG = JSON.stringify(userGuest)
    localStorage.setItem("userGuest", uG)
  }, [])



  useEffect(() => {
    if (location.pathname.toLowerCase().includes(`startup`)) {
      return setWhoLogsIn(1)
    }
    return setWhoLogsIn(2)
  }, [location])

  const handleLoginResponse = async (resp: ApiSimpleResponse<LoginResponse>, setSubmitting: (isSubmitting: boolean) => void, isStartUp: boolean) => {

    if (!resp.isSuccess || !resp.response) {
      saveAuth(null)
      setSubmitting(false)
      setErrorModal(!!resp.error ? resp.error : "Invalid login or password")
      setIsChooseNewPassword(false)
      setIsForgotPassword(false)
      return
    }

    const auth = { ...resp.response, isStartUp: isStartUp }
    saveAuth(auth)

    axios.defaults.headers.common['Authorization'] = "Bearer " + resp.response?.jwtToken;

    const getUserResponse = await getUser();

    if (!getUserResponse.isSuccess || !getUserResponse.response) {
      setCurrentUser(undefined)
      setSubmitting(false)
      setErrorModal(!!getUserResponse.error ? getUserResponse.error : "Invalid login or password")
      return
    }


    setCurrentUser({ ...getUserResponse.response, roleType: whoLogsIn })

    const dataUserLoaded = await getUserData(whoLogsIn)

    if (!dataUserLoaded) {
      setErrorModal()
      setIsChooseNewPassword(false)
      setIsForgotPassword(false)
      return
    }

    setClosedModal()
    setIsChooseNewPassword(false)
    setIsForgotPassword(false)

    if (!!location?.state?.prevPath) {
      navigate(location.state.prevPath) 
      return
    }

    if (whoLogsIn === LoginType.startup) {
      navigate("/start-up/profile")
      return
    }
    navigate("/corporate/profile")

  }

  const loginWithLinkedin = () => {
    // API return LinkedIn redirect URL
    getLinkedInAuthUrl(LinkedInRedirectType.LOGIN).then((resp) => {
      if (resp.isSuccess && !!resp.response?.data) {
        if (userGuest && userGuest.featuredStartupID
          && userGuest.date1 && userGuest.date2 && userGuest.date3) {
          let dates: MatchDate[] = [
            {
              id: "firstDate",
              date: userGuest.date1
            },
            {
              id: "secondDate",
              date: userGuest.date2
            },
            {
              id: "thirdDate",
              date: userGuest.date3
            }
          ]

          getStartUpByID(userGuest.featuredStartupID).then((res) => {
            let resp = res.response?.data
            if (res.isSuccess) {
              setCanMatch(resp?.canMatch)
              setMatchCallDates(dates)
              navigate(`/corporate/startup-profile/${userGuest.featuredStartupID}`)
              setModalDatesIsOpen(true);
              resetGuest()
            } else {
              setModalDatesIsOpen(false);
            }
          })
        } else {
          window.location.replace(resp.response.data)
        }
      }
    })
  }


  useEffect(() => {
    setLogInAsText(`as ${whoLogsIn === LoginType.corporate ? 'Innovation Seeker' : 'Innovation Provider'}`)
  }, [whoLogsIn])

  const formik = useFormik<LogInData>({
    initialValues: logiDataInfo,
    validationSchema: loginDataSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      setLoadingModal();

      const loginRequest: LoginRequest = {
        email: values.user,
        password: values.password,
        isStartup: whoLogsIn === LoginType.startup
      }

      const loginResponse = await postLogin(loginRequest);
      handleLoginResponse(loginResponse, setSubmitting, loginRequest.isStartup)
    }
  })

  const showFP = useMemo(() => {

    if (isForgotPassword && !isChooseNewPassword) {
      return <ForgotPassword  whoLogsIn={whoLogsIn}/>
    }

    if (!isForgotPassword && isChooseNewPassword) {
      return <ChooseNewPassword handleLoginResponse={handleLoginResponse}   whoLogsIn={whoLogsIn}/>
    }
    const registerPath = loginType === LoginType.startup ? '/startup' : ''

    return (
      <form onSubmit={formik.handleSubmit} autoComplete='off' id='formLogin'>

        {/* user*/}
        <label className='text-black mt-3' htmlFor="user">Username or Email<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <input
          autoComplete="new-password"
          placeholder='Your Username or Email'
          {...formik.getFieldProps('user')}
          className="form-input"
          type="text"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("user", true)}
          value={formik.values.user}
          name="user"
        />
        {formik.errors.user && formik.touched.user && <div className='text-error ms-2' id="user">{formik.errors.user}</div>}

        {/* password */}
        <label className='text-black mt-3' htmlFor="Password">Password<sup className='text-error' style={{ fontSize: "16px" }}>*</sup></label>
        <input
          autoComplete="new-password"
          placeholder='Password'
          {...formik.getFieldProps('password')}
          className="form-input"
          type="password"
          onChange={formik.handleChange}
          onBlur={() => formik.setFieldTouched("password", true)}
          value={formik.values.password}
          name="password"
        />
        {formik.errors.password && formik.touched.password && <div className='text-error ms-2' id="password">{formik.errors.password}</div>}

        <div className='d-flex justify-content-end'>
          <p onClick={() => setIsForgotPassword(true)} className='tx-primary cursor-pointer mt-3'>Forgot Password?</p>
        </div>

        <div className={clsx(
          'd-flex   mt-2 ',
          { 'justify-content-end': whoLogsIn === LoginType.startup },
          { 'justify-content-end flex-wrap': whoLogsIn === LoginType.corporate },
        )}>
          {whoLogsIn === LoginType.corporate &&
            <Button
              borderColor="var(--linkedin)"
              color="var(--linkedin)"
              className={clsx(" linkedin-button",
                { "mt-1 ms-1": !buttonsColumns },
                { "mb-3 ms-0": buttonsColumns },
                { "fs-11 w-100": mobile }
              )}
              type={'button'}
              background="var(--white)"
              icon={<Linkedin className="started-linkedin" />}
              fontWeight={"800"}
              uppercase
              text="login with linkedin"
              onClick={loginWithLinkedin}
            />
          }
          <Button
            className={clsx('mt-1 ms-1 ', { "w-100": mobile })}
            color='var(--white)'
            background='var(--primary)'
            borderColor='var(--primary)'
            fontWeight={'800'}
            uppercase
            primary
            text={`login`} 
            type='submit'
            />


        </div>
        <div className={clsx('d-flex justify-content-end  pb-5 mb-5 ')}>
          <p className='mt-3'>
            not yet on Innovation Match?
            <Link to={`/getStarted${registerPath}`} className='ms-1 link tx-underline'>
              Register Now
            </Link>
          </p>
        </div>

      </form >
    )

  }, [isForgotPassword, isChooseNewPassword, whoLogsIn, formik,logInAsText, buttonsColumns,mobile, loginType])



/*

                    const registerPath = loginType === LoginType.startup ? '/startup' : ''
                    navigate(`/getStarted${registerPath}`)
*/


  return (
    <div className={clsx("container-fluid w-100 h-100  m-0  mt-3 ",
      { "p-0": tablet },
      { "p-0  d-flex align-items-center justify-content-center pb-5": !tablet })}>
      <div className={clsx("d-flex justify-content-center align-items-center position-relative  h-100   max-h-600px",
        { "w-100 p-0 m-0 ": tablet },
        { "login-container": !tablet })}>
        {/* LEFT SECTION */}
        {!tablet && <div className="col-6 image-col-login d-flex align-items-start h-100  ">
          <img src={loginImg} className='img-login' alt="" />
        </div>}
        {/* RIGHT SECTION */}
        <div className={clsx(
          'p-0 d-flex h-100    ',
          { 'align-items-center m-0 ': !heigth700 },
          { "col-6 overflow-y": !tablet },
          { "col-12": tablet },
          { "mt-0": mobile }
        )} >
          <div className='w-100 h-100 ' >
            <div className='bg-white p-5 '>
              <div className='square-right ' />
              <div className='d-flex '>
                <div
                  onClick={() => {
                    if(isChooseNewPassword){return}
                    console.log(LoginType.startup)
                    setWhoLogsIn(LoginType.startup); setLoginType(LoginType.startup) 
                  }}
                  className={clsx(
                    'border-right-gray border-bottom-gray p-2 min-width-40 ',
                    { 'tx-primary': whoLogsIn === LoginType.startup },
                    {"cursor-pointer" : !isChooseNewPassword}
                  )} >
                  Innovation Provider
                </div>
                <div
                  onClick={() => { 
                    if(isChooseNewPassword){return}
                    console.log(LoginType.corporate)
                    setWhoLogsIn(LoginType.corporate); setLoginType(LoginType.corporate)
                   }}
                  className={clsx(
                    'border-bottom-gray p-2 min-width-40',
                    { 'tx-primary': whoLogsIn === LoginType.corporate },
                    {"cursor-pointer" : !isChooseNewPassword}
                  )} >
                  Innovation Seeker
                </div>
              </div>
              <h4 className='mt-3'>{isForgotPassword || isChooseNewPassword ? "Forgot Password" : `Log In ${logInAsText}`} </h4>
              <div className=''>
                {showFP}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
}
